// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';

const useSessionTimeout = (minutes: number, notifyMinutes: number, onIdle: any, onTimeoutWarning: any) => {
    if (!minutes) {
        return { isIdle: false };
    }

    const [timeRemaining, setTimeRemaining] = useState(notifyMinutes * 60);
    
    const handleUserActivity = () => {
        reset();
        setTimeRemaining(notifyMinutes * 60);
    };

    const { isIdle, reset } = useIdleTimer({
        onIdle,
        timeout: 1000 * 60 * minutes,
        crossTab: true,
        leaderElection: true,
        syncTimers: 200,
        stopOnIdle: true,
        events: ["keydown", "mousedown", "touchstart", "touchmove", "MSPointerDown", "MSPointerMove"],
        onAction: handleUserActivity,
    });

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeRemaining(prevTime => prevTime - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!timeRemaining) {
            onTimeoutWarning();
            setTimeRemaining(notifyMinutes * 60);
        }
    }, [timeRemaining, onTimeoutWarning]);

    return { isIdle, handleUserActivity };
};

export default useSessionTimeout;
